import { useParams } from "react-router-dom";

export function useProgressCheckPdfParamsOrThrow() {
  const { level, userGroupId } = useParams();
  if (!level || !userGroupId) {
    throw new Error("Missing route params: level or userGroupId");
  }
  return { level, userGroupId };
}
